import { ICPlatformVersion } from '@retailer-platform/dashboard/access-control'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const customersAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.CustomersCustomersView, Permission.StoreConfigsView],
  restrictedBannersAllowed: true,
}

export const customersPrivacyRequestsAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.StoreConfigsView, Permission.CustomersPrivacyRequestsModifyAccess],
  restrictedBannersAllowed: true,
}

export const guestManagementEnhancements: DomainAccessControlConfig = [
  {
    warehouseFeatureToggles: [FeatureToggle.GuestManagementEnhancements],
    restrictedBannersAllowed: true,
  },
  {
    minICPlatformVersion: ICPlatformVersion.r2024_06_0,
    restrictedBannersAllowed: true,
  },
]

// Release dependency for the R2026_07 rollout of the newest IPP Customer Profile
// additions (PCR-654 items 3-5: the promotions/credits card, the gift-cards card,
// and the order-history tab). Mirrors `guestManagementEnhancements` but pinned to
// the R2026_07 platform version, with the guest-management warehouse toggle as the
// early-access lever for a pilot retailer.
//
// Items 1/2/6 stay on `guestManagementEnhancements` (still pinned to r2024_06_0)
// until the release manager signs off on bumping that gate to r2026_07_0, which
// would pull those already-live features back from sub-r2026_07 retailers. See
// PL-67222.
export const storedValueAndOrderHistoryEnhancements: DomainAccessControlConfig = [
  {
    warehouseFeatureToggles: [FeatureToggle.GuestManagementEnhancements],
    restrictedBannersAllowed: true,
  },
  {
    minICPlatformVersion: ICPlatformVersion.r2026_07_0,
    restrictedBannersAllowed: true,
  },
]

export const appeasementDisableCustomAmount: DomainAccessControlConfig = {
  warehouseFeatureToggles: [FeatureToggle.AppeasementDisableCustomAmount],
  restrictedBannersAllowed: true,
}

export const newAppeasementSectionAccessControl: DomainAccessControlConfig = {
  warehouseFeatureToggles: [FeatureToggle.AppeasementEnableNewSection],
  restrictedBannersAllowed: true,
}
